<div class="d-flex product-list-item-doc" *ngIf="!isMobile && product">
   <div class="col-12 col-md-4">
      <div class="d-flex">
         <div class="product-code" [innerHtml]="product.code| searchHighlight:searchQuery"></div>
         <ng-container *ngIf="isLoggedIn">
            <div (click)="addfav = !addfav" (mouseenter)="tooltip = true" (mouseleave)="tooltip = false">
               <img *ngIf="tooltip" (click)="SubscribeDoc(product)"
                  [attr.src]="tooltip ?  'icons/icon_star_active.svg' :  'icons/icon_star.svg'" alt=""
                  class="icon-star">
               <img *ngIf="!tooltip" [attr.src]="addfav ?  'icons/icon_star_active.svg' :  'icons/icon_star.svg'" alt=""
                  class="icon-star">
               <span class="tooltip-AddtoFavorites" *ngIf="tooltip">Add to favorites
               </span>
            </div>
         </ng-container>
      </div>
      <!-- <div class="doc-desc" [innerHTML]="product.description"></div> -->
      <div class="doc-type" [innerHTML]="product.productGroup | searchHighlight:searchQuery"></div>
      <div class="doc-type"
         [innerHTML]="(product.productCategory && product.productCategory.length)?  product?.productCategory[0] : '' | searchHighlight:searchQuery">
      </div>
      <div class="doc-typeCode" [innerHTML]="product.docType| searchHighlight:searchQuery"></div>

   </div>
   <div class="col-12 col-md-4">
      <div class="doc-type min-height-empty" *ngIf="product.revision ;else noData">
         Rev: {{product.revision | searchHighlight:searchQuery}}
      </div>
      <ng-template #noData>
         <div class="doc-type min-height-empty"></div>
      </ng-template>
      <div class=" doc-type" [innerHtml]="product.description | searchHighlight:searchQuery"></div>
      <div class="doc-type" [innerHtml]="product.docSuppText | searchHighlight:searchQuery"></div>
      <div class="doc-type" [innerHtml]="product.docAddText | searchHighlight:searchQuery"></div>


   </div>
   <div class="d-flex col-12 col-md-4 document-col-end">
      <!--   <div class="d-flex flex-column col-md-6">


         <label class="doc-revision">Revision : {{product.revision}}</label>

         <label class="doc-releasedate">Release Date : {{product.releaseDate}}</label>

      </div> -->
      <div class="download-btn-outer">
         <div class="download-btn-outer"
            *ngIf="(product?.url?.toLowerCase()?.includes('.pdf') || product?.url?.toLowerCase()?.includes('.tif'));else download">
            <a class="btn button" (click)="downloadPopup(product)">
               Download Document
               <img src=" icons/link-grey.svg" class="icon-right">
            </a>
         </div>
      </div>
      <ng-template #download>
         <div class="download-btn-outer">
            <a href={{product.url}} target="_blank" class="btn button-launch" rel="noopener">
               Launch Video
            </a>
         </div>
      </ng-template>
   </div>

</div>
<div *ngIf="isMobile && product">

   <div class="details">
      <div class="product-description">
         <label class="product-code" [innerHtml]="product.code | searchHighlight:searchQuery"></label>
         <div class="doc-desc" [innerHtml]="product.productGroup | searchHighlight:searchQuery"></div>
         <div class="doc-desc" [innerHtml]="product.docSuppText | searchHighlight:searchQuery"></div>
         <div class="doc-desc" [innerHtml]="product.docAddText | searchHighlight:searchQuery"></div>

         <div class="doc-desc"
            [innerHTML]="(product.productCategory && product.productCategory.length)?  product?.productCategory[0] : '' | searchHighlight:searchQuery">
         </div>
         <div class="doc-normal-text" [innerHTML]="product.docTypeCode | searchHighlight:searchQuery"></div>
         <div class="doc-type" [innerHTML]="product.docType | searchHighlight:searchQuery"></div>

         <div class="doc-details" *ngIf="product.revision">Rev : {{product.revision}}</div>
         <!--  <div class="doc-details">>Release Date : {{product.releaseDate}}
      </div> -->

      </div>
      <div class="download-btn-outer">
         <div class="download-btn-outer"
            *ngIf="(product?.url?.toLowerCase()?.includes('.pdf') || product?.url?.toLowerCase()?.includes('.tif'));else download">
            <a (click)=" downloadPopup(product)" class="btn button">
               Download Document
               <img src=" icons/link-white.svg" class="icon-right">
            </a>
         </div>
      </div>
      <ng-template #download>
         <div class="download-btn-outer">
            <a href={{product.url}} target="_blank" class="btn button-launch" rel="noopener">
               Launch Video
            </a>
         </div>
      </ng-template>
   </div>
</div>